import {
  action, makeObservable, observable,
} from "mobx";
import { IRootStore } from "../types/IRootStore";
import { IQuoteTemplateInput } from "../types/IQuoteTemplate";
import {
  createSignatureInput, deleteSignatureInput, fetchSignatureInputs, updateSignatureInput,
} from "../requests/quoteTemplates/signatureInputs";

export class SignatureStore {
  rootStore;

  @observable signatureInputs: IQuoteTemplateInput[] = [];

  constructor(rootStore: IRootStore) {
    makeObservable(this);

    this.rootStore = rootStore;
  }

  @action
    getSignatureInputs = async (templateId: number) => {
      const result = await fetchSignatureInputs(templateId);
      this.setSignatureInputs(result);
    };

  @action
  setSignatureInputs(signatureInputs: IQuoteTemplateInput[]) {
    this.signatureInputs = signatureInputs;
  }

  @action
    addSignatureInput = async (
      templateId: number,
      payload: { attributes: Partial<IQuoteTemplateInput["attributes"]> },
    ) => {
      const created = await createSignatureInput(templateId, payload);
      this.setSignatureInputs([...this.signatureInputs, created]);
    };

  @action
    updateSignatureInput = async (
      templateId: number,
      id: string,
      payload: { attributes: Partial<IQuoteTemplateInput["attributes"]> },
    ) => {
      const updated = await updateSignatureInput(templateId, id, payload);
      this.signatureInputs = this.signatureInputs.map((input) => {
        const isMatch = input.attributes.id === id;
        return isMatch ? updated : input;
      });
    };

  @action
    deleteSignatureInput = async (templateId: number, id: string) => {
      await deleteSignatureInput(templateId, id);
      this.signatureInputs = this.signatureInputs.filter((input) => input.attributes.id !== id);
    };
}

export default SignatureStore;
